import { gql } from 'apollo-boost'

export const GET_AVAILABLE_VISITATION_RAFFLES = gql`
  query GetAvailableVisitationRaffles {
    listUserVisitEvents {
      visitEvent {
        id
        createdAt
        date
        eventStatus
        closeSubscribeListDate
        drawDate
        maxVisitors
        eventStatus
        construction {
          id
        }
      }
      subscription {
        status
        placing
      }
    }
  }
`
